<app-form-box>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<app-form-label>Reset Password</app-form-label>
		<p>(check your email)</p>

		<br />

		<app-text-field
			[fg]="form"
			formGroupOrControlName="username"
			label="E-Mail"
			placeholder="E-Mail"
			autocomplete="username"
		></app-text-field>

		<br />

		<app-text-field
			[fg]="form"
			formGroupOrControlName="verificationCode"
			label="Verification Code"
			autocomplete="one-time-code"
		></app-text-field>

		<br />

		<app-password-requirements></app-password-requirements>

		<br />

		<app-password-field
			[fg]="form"
			formGroupOrControlName="password"
			label="New Password"
			autocomplete="new-password"
		></app-password-field>

		<app-form-submit-button [disabled]="!form.valid || loading" [loading]="loading">
			Reset Password
		</app-form-submit-button>
	</form>

	<br />

	<div class="footer-links">
		<app-form-link (click)="onBack()">Back</app-form-link>
	</div>
</app-form-box>
